import React from "react";

function ContactUs() {
  return (
    <>
     <section id="contact" >
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-5">
              <span className="section-subtitle">CONTACT</span>

              <h2 className="section-title">Get in Touch</h2>

              <p className="section-text">
                Have questions or need medical assistance? Our team is ready
                to help you.
              </p>

              <div className="contact-info">
                <div className="contact-item">
                  <i className="bi bi-geo-alt-fill"></i>

                  <div>
                    <h5>Address</h5>
                    <p>
                      362 Parsippany Rd
                      <br />
                      Parsippany, NJ 07054
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <i className="bi bi-telephone-fill"></i>

                  <div>
                    <h5>Phone</h5>
                    <p>+1 (973) 515-0777</p>
                  </div>
                </div>

                <div className="contact-item">
                  <i className="bi bi-envelope-fill"></i>

                  <div>
                    <h5>Email</h5>
                    <p>info@DrSadhanaKumar.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <form className="contact-form">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                    />
                  </div>

                  <div className="col-md-6 mb-4">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                    />
                  </div>
                </div>

                <input
                  type="text"
                  className="form-control mb-4"
                  placeholder="Subject"
                />

                <textarea
                  rows="6"
                  className="form-control mb-4"
                  placeholder="Your Message"
                ></textarea>

                <button type="submit" className="btn book-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default ContactUs;